
  import Vue from 'vue';
  import PopularCategoryCard from '@/components/PopularCategoryCard';
export default {
  components: {
    PopularCategoryCard
  },
  head() {
    return {
      title: this.title,
      meta: [
        {
          hid: 'og:title',
          property: 'og:title',
          content: this.title,
        },
        {
          hid: 'twitter:title',
          property: 'twitter:title',
          content: this.title,
        },
        {
  hid: 'description',
  name: 'description',
  content: 'Enjoy a relaxing Mandovi River cruise in Goa, where you can take in beautiful views, tasty food, and a peaceful atmosphere. Perfect for a day out with family or friends.',
},
{
  hid: 'og:description',
  property: 'og:description',
  content: 'Discover the charm of Mandovi River cruises in Goa, featuring stunning river views, delicious meals, and a calming experience to create special moments with loved ones.',
},
{
  hid: 'twitter:description',
  property: 'twitter:description',
  content: 'Set sail on a Mandovi River cruise in Goa, enjoying good food, beautiful sights, and a friendly atmosphere. Great for fun outings with family or friends!',
},


        {
          hid: 'keywords',
          name: 'keywords',
          content: 'mandovi river cruise, mandovi river cruise goa, mandovi river cruise price, mandovi river cruise timings, mandovi river cruise booking',
        },

      ],
    };
  },

  components: {},
  data() {
    return {

      reasons: [
    {
      title: "Scenic Locations",
      text: "Enjoy breathtaking views of Goa's coastline and rivers with our boat cruises!",
    },
    {
      title: "Fun for Everyone",
      text: "Whether it's a family trip or a romantic outing, there's a boat cruise for every occasion!",
    },
    {
      title: "Expert Crew",
      text: "Our friendly and experienced crew ensures you have a safe and memorable journey.",
    },
    {
      title: "Easy Booking",
      text: "Book your perfect boat cruise effortlessly through the Goa App at great rates!",
    },
  ],
     
      title: 'Mandovi River Cruise in Goa - Mandovi River Cruise Price, Timings and Location',
    };
  },

  jsonld() {
  return {
    '@context': 'https://schema.org',
    '@graph': [
    {
                "@type": "ImageObject",
                "@id": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2024-04-18T12%3A19%3A29.851ZMandovi-river.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=CzvdzblFRNX8VCMOXo%2FG%2FCYoTNpkYmPzD98ignMFGsrX9qIxFwoamCDG4%2FXtDWUM2%2Bu8C%2B2RAH6gVKViqTETad2JLunx53M29gPeaKLfh%2FYqE6E6Eu%2FXuUBEGyPl25DcHvtg9RlcMtkzQEbqT8C2TdCY3utcQinETWIGqg5AymMb%2BVw4wDcFyV70skJHGEdiLrkkjrFKBTo0pBNV7sGRxGAszEwwx8KSEUPirNBa80MqtGXLRw89qCBVu4lTTOIh7XrJ0nIW7lAt2LhZL5Vec1Avn7fPLVsE3DX4NYHc5SqA1txL4O2tkS%2FweTdJEExs9%2BrUpFD6AAvXdA5TVCGYAQ%3D%3D',
                "url": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2024-04-18T12%3A19%3A29.851ZMandovi-river.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=CzvdzblFRNX8VCMOXo%2FG%2FCYoTNpkYmPzD98ignMFGsrX9qIxFwoamCDG4%2FXtDWUM2%2Bu8C%2B2RAH6gVKViqTETad2JLunx53M29gPeaKLfh%2FYqE6E6Eu%2FXuUBEGyPl25DcHvtg9RlcMtkzQEbqT8C2TdCY3utcQinETWIGqg5AymMb%2BVw4wDcFyV70skJHGEdiLrkkjrFKBTo0pBNV7sGRxGAszEwwx8KSEUPirNBa80MqtGXLRw89qCBVu4lTTOIh7XrJ0nIW7lAt2LhZL5Vec1Avn7fPLVsE3DX4NYHc5SqA1txL4O2tkS%2FweTdJEExs9%2BrUpFD6AAvXdA5TVCGYAQ%3D%3D',
                "contentUrl": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2024-04-18T12%3A19%3A29.851ZMandovi-river.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=CzvdzblFRNX8VCMOXo%2FG%2FCYoTNpkYmPzD98ignMFGsrX9qIxFwoamCDG4%2FXtDWUM2%2Bu8C%2B2RAH6gVKViqTETad2JLunx53M29gPeaKLfh%2FYqE6E6Eu%2FXuUBEGyPl25DcHvtg9RlcMtkzQEbqT8C2TdCY3utcQinETWIGqg5AymMb%2BVw4wDcFyV70skJHGEdiLrkkjrFKBTo0pBNV7sGRxGAszEwwx8KSEUPirNBa80MqtGXLRw89qCBVu4lTTOIh7XrJ0nIW7lAt2LhZL5Vec1Avn7fPLVsE3DX4NYHc5SqA1txL4O2tkS%2FweTdJEExs9%2BrUpFD6AAvXdA5TVCGYAQ%3D%3D',
                "caption": 'Goa App',
                "inLanguage": "en-US",
                "width": 800,
                "height": 440
            }, 
            {
            "@type": "BlogPosting",
            "@id": `https://www.goa.app/mandovi-river-cruise`,
                mainEntityOfPage: {
                    '@type': 'WebPage',
                    '@id': `https://www.goa.app/mandovi-river-cruise`
                },
                "headline": 'Goa App',
                "name": 'Goa App',
                description: '',
                datePublished: '2024-10-26T20:14:36+00:00',
                dateModified: '2024-10-26T20:14:36+00:00',
                author: {
                    '@type': 'Person',
                    name: 'Goa App',
                    url: "https://goa.app"
                },
                publisher: {
                    '@type': 'Organization',
                    "@id": "https://goa.app",
                    name: 'Goa App',
                    logo: {
                        '@type': 'ImageObject',
                        url: 'https://goa.app/goa-app-logo.svg'
                    }
                },
                "image": {
                    "@type": "ImageObject",
                    "@id": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2024-04-18T12%3A19%3A29.851ZMandovi-river.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=CzvdzblFRNX8VCMOXo%2FG%2FCYoTNpkYmPzD98ignMFGsrX9qIxFwoamCDG4%2FXtDWUM2%2Bu8C%2B2RAH6gVKViqTETad2JLunx53M29gPeaKLfh%2FYqE6E6Eu%2FXuUBEGyPl25DcHvtg9RlcMtkzQEbqT8C2TdCY3utcQinETWIGqg5AymMb%2BVw4wDcFyV70skJHGEdiLrkkjrFKBTo0pBNV7sGRxGAszEwwx8KSEUPirNBa80MqtGXLRw89qCBVu4lTTOIh7XrJ0nIW7lAt2LhZL5Vec1Avn7fPLVsE3DX4NYHc5SqA1txL4O2tkS%2FweTdJEExs9%2BrUpFD6AAvXdA5TVCGYAQ%3D%3D',
                    "url": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2024-04-18T12%3A19%3A29.851ZMandovi-river.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=CzvdzblFRNX8VCMOXo%2FG%2FCYoTNpkYmPzD98ignMFGsrX9qIxFwoamCDG4%2FXtDWUM2%2Bu8C%2B2RAH6gVKViqTETad2JLunx53M29gPeaKLfh%2FYqE6E6Eu%2FXuUBEGyPl25DcHvtg9RlcMtkzQEbqT8C2TdCY3utcQinETWIGqg5AymMb%2BVw4wDcFyV70skJHGEdiLrkkjrFKBTo0pBNV7sGRxGAszEwwx8KSEUPirNBa80MqtGXLRw89qCBVu4lTTOIh7XrJ0nIW7lAt2LhZL5Vec1Avn7fPLVsE3DX4NYHc5SqA1txL4O2tkS%2FweTdJEExs9%2BrUpFD6AAvXdA5TVCGYAQ%3D%3D',
                    "height": "440",
                    "width": "800"
                },
                "url": `https://www.goa.app/mandovi-river-cruise`,
                "isPartOf": {
                    "@type": "Blog",
                    "@id": "https://www.goa.app/",
                    "name": "Goa App Blog",
                    "publisher": {
                        "@type": "Organization",
                        "@id": "https://goa.app",
                        "name": "Goa App"
                    }
                },
            },
            
            {
  "@type": "Product",
  "name": "Mandovi River Cruise - Book @ ₹1299 Flat 50% Off",
  "description": "Experience a Mandovi River Cruise in Goa with scenic views, delicious meals, and live entertainment, perfect for a memorable evening.",
  "image": "https://storage.googleapis.com/goa-app-12a91.appspot.com/2024-04-18T12%3A19%3A29.851ZMandovi-river.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=CzvdzblFRNX8VCMOXo%2FG%2FCYoTNpkYmPzD98ignMFGsrX9qIxFwoamCDG4%2FXtDWUM2%2Bu8C%2B2RAH6gVKViqTETad2JLunx53M29gPeaKLfh%2FYqE6E6Eu%2FXuUBEGyPl25DcHvtg9RlcMtkzQEbqT8C2TdCY3utcQinETWIGqg5AymMb%2BVw4wDcFyV70skJHGEdiLrkkjrFKBTo0pBNV7sGRxGAszEwwx8KSEUPirNBa80MqtGXLRw89qCBVu4lTTOIh7XrJ0nIW7lAt2LhZL5Vec1Avn7fPLVsE3DX4NYHc5SqA1txL4O2tkS%2FweTdJEExs9%2BrUpFD6AAvXdA5TVCGYAQ%3D%3D",
  "review": {
    "@type": "Review",
    "reviewRating": {
      "@type": "Rating",
      "ratingValue": "5",
      "bestRating": "5"
    },
    "author": {
      "@type": "Person",
      "name": "Goa App"
    }
  },
  "brand": {
    "@type": "Brand",
    "name": "Goa App"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "ratingCount": "89",
    "ratingValue": "5",
    "reviewCount": "44"
  },
  "offers": {
    "@type": "Offer",
    "price": "1299",
    "priceValidUntil": "2025-12-31",
    "priceCurrency": "INR",
    "availability": "InStock",
    "seller": {
      "@type": "Organization",
      "name": "Goa App"
    }
  }
},

            {
        "@type": "WebPage",
        "@id": "https://www.goa.app/mandovi-river-cruise",
        "url": "https://www.goa.app/mandovi-river-cruise",
        "name": "Mandovi River Cruise",
        "isPartOf": {
            "@id": "https://www.goa.app/#website"
        },
        "primaryImageOfPage": {
            "@id": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2024-04-18T12%3A19%3A29.851ZMandovi-river.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=CzvdzblFRNX8VCMOXo%2FG%2FCYoTNpkYmPzD98ignMFGsrX9qIxFwoamCDG4%2FXtDWUM2%2Bu8C%2B2RAH6gVKViqTETad2JLunx53M29gPeaKLfh%2FYqE6E6Eu%2FXuUBEGyPl25DcHvtg9RlcMtkzQEbqT8C2TdCY3utcQinETWIGqg5AymMb%2BVw4wDcFyV70skJHGEdiLrkkjrFKBTo0pBNV7sGRxGAszEwwx8KSEUPirNBa80MqtGXLRw89qCBVu4lTTOIh7XrJ0nIW7lAt2LhZL5Vec1Avn7fPLVsE3DX4NYHc5SqA1txL4O2tkS%2FweTdJEExs9%2BrUpFD6AAvXdA5TVCGYAQ%3D%3D'
        },
        "image": {
            "@id": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2024-04-18T12%3A19%3A29.851ZMandovi-river.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=CzvdzblFRNX8VCMOXo%2FG%2FCYoTNpkYmPzD98ignMFGsrX9qIxFwoamCDG4%2FXtDWUM2%2Bu8C%2B2RAH6gVKViqTETad2JLunx53M29gPeaKLfh%2FYqE6E6Eu%2FXuUBEGyPl25DcHvtg9RlcMtkzQEbqT8C2TdCY3utcQinETWIGqg5AymMb%2BVw4wDcFyV70skJHGEdiLrkkjrFKBTo0pBNV7sGRxGAszEwwx8KSEUPirNBa80MqtGXLRw89qCBVu4lTTOIh7XrJ0nIW7lAt2LhZL5Vec1Avn7fPLVsE3DX4NYHc5SqA1txL4O2tkS%2FweTdJEExs9%2BrUpFD6AAvXdA5TVCGYAQ%3D%3D'
        },
        "thumbnailUrl": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2024-04-18T12%3A19%3A29.851ZMandovi-river.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=CzvdzblFRNX8VCMOXo%2FG%2FCYoTNpkYmPzD98ignMFGsrX9qIxFwoamCDG4%2FXtDWUM2%2Bu8C%2B2RAH6gVKViqTETad2JLunx53M29gPeaKLfh%2FYqE6E6Eu%2FXuUBEGyPl25DcHvtg9RlcMtkzQEbqT8C2TdCY3utcQinETWIGqg5AymMb%2BVw4wDcFyV70skJHGEdiLrkkjrFKBTo0pBNV7sGRxGAszEwwx8KSEUPirNBa80MqtGXLRw89qCBVu4lTTOIh7XrJ0nIW7lAt2LhZL5Vec1Avn7fPLVsE3DX4NYHc5SqA1txL4O2tkS%2FweTdJEExs9%2BrUpFD6AAvXdA5TVCGYAQ%3D%3D',
        "datePublished": "2024-10-26T20:14:36+00:00",
        "dateModified": "2024-10-26T20:14:36+00:00",
        "description": "Mandovi River Cruise offers a memorable experience with scenic views, lively entertainment, and great vibes. Ideal for celebrations or special occasions, these cruises let you enjoy Goa’s beauty and vibrant atmosphere while partying along its rivers or coastline.",
        "breadcrumb": {
            "@id": "https://www.goa.app/mandovi-river-cruise/#breadcrumb"
        },
        "inLanguage": "en-US",
        "potentialAction": [{
            "@type": "ReadAction",
            "target": ["https://www.goa.app/mandovi-river-cruise"]
        }]
      },
      {
        "@type": "FAQPage",
  "mainEntity": [
  {
  "@type": "Question",
  "name": "How do I book a Mandovi River Cruise?",
  "acceptedAnswer": {
    "@type": "Answer",
    "text": "You can book a Mandovi River Cruise through various online platforms or by contacting local operators. Booking in advance, especially during peak season, is recommended to secure your spot."
  }
},
{
  "@type": "Question",
  "name": "What is included in a Mandovi River Cruise package?",
  "acceptedAnswer": {
    "@type": "Answer",
    "text": "Mandovi River Cruise packages typically include the cruise, crew, and basic amenities. Some packages offer extras like meals, beverages, and entertainment on board."
  }
},
{
  "@type": "Question",
  "name": "What should I wear for a Mandovi River Cruise?",
  "acceptedAnswer": {
    "@type": "Answer",
    "text": "It’s recommended to wear comfortable, smart casual attire. Dress for the weather and don't forget your swimwear if you plan to take a dip or engage in water activities."
  }
},
{
  "@type": "Question",
  "name": "How long can I enjoy the Mandovi River Cruise?",
  "acceptedAnswer": {
    "@type": "Answer",
    "text": "Mandovi River Cruises can last anywhere from a couple of hours to a full day, depending on the package. Longer cruises for special occasions can often be arranged."
  }
},
{
  "@type": "Question",
  "name": "Can I customize the experience on a Mandovi River Cruise?",
  "acceptedAnswer": {
    "@type": "Answer",
    "text": "Yes, many operators allow customization for special occasions such as birthdays or anniversaries. You can add elements like decorations, meals, and entertainment."
  }
},
{
  "@type": "Question",
  "name": "Are meals and drinks included in the Mandovi River Cruise?",
  "acceptedAnswer": {
    "@type": "Answer",
    "text": "Some Mandovi River Cruises include meals and drinks, while others may offer them as an optional add-on. It's best to confirm with the cruise provider when booking."
  }
},
{
  "@type": "Question",
  "name": "What is the price range for Mandovi River Cruises?",
  "acceptedAnswer": {
    "@type": "Answer",
    "text": "Prices for Mandovi River Cruises typically start from ₹500 and can go up depending on the duration, inclusions, and amenities offered."
  }
},
{
  "@type": "Question",
  "name": "Can I book a Mandovi River Cruise for a special occasion?",
  "acceptedAnswer": {
    "@type": "Answer",
    "text": "Yes, Mandovi River Cruises are perfect for special occasions like anniversaries or celebrations. Many operators offer tailor-made packages for such events."
  }
},
{
  "@type": "Question",
  "name": "What is the best time to book a Mandovi River Cruise?",
  "acceptedAnswer": {
    "@type": "Answer",
    "text": "The best time to book a Mandovi River Cruise is between November and February when the weather is pleasant. However, cruises are available year-round for a memorable experience."
  }
},
{
  "@type": "Question",
  "name": "Can I bring my own food and drinks on a Mandovi River Cruise?",
  "acceptedAnswer": {
    "@type": "Answer",
    "text": "Some Mandovi River Cruise operators allow you to bring your own food and beverages, while others provide catering services. It's advisable to check with the provider in advance."
  }
},
{
  "@type": "Question",
  "name": "Are Mandovi River Cruises suitable for water sports?",
  "acceptedAnswer": {
    "@type": "Answer",
    "text": "Yes, many Mandovi River Cruises offer additional water sports activities such as jet skiing and fishing. You can inquire about these options when booking your cruise."
  }
}




]
      }
    ]
  };
},

};

  